const TimeAndDate = () =>
{
	const currentTime = new Date();
	const obj = {
		Date : '',
		Time : ''
	};

	const weekday = currentTime.toLocaleDateString('en-IN', { weekday: 'long' });
	const day = currentTime.toLocaleDateString('en-IN', { day: 'numeric' });
	const month = currentTime.toLocaleDateString('en-IN', { month: 'long' });
	const year = currentTime.toLocaleDateString('en-IN', { year: 'numeric' });

	const formattedTime = currentTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
	const getDaySuffix = (dayValue) =>
	{
		if (dayValue >= 11 && dayValue <= 13)
		{
			return 'th';
		}
		switch (dayValue % 10)
		{
			case 1:
				return 'st';
			case 2:
				return 'nd';
			case 3:
				return 'rd';
			default:
				return 'th';
		}
	};
	const daySuffix = getDaySuffix(day);

	obj.Date = `${weekday} , ${day}${daySuffix} ${month} ${year}`;
	obj.Time = formattedTime;

	return obj;

};

export default TimeAndDate;
